import React from 'react';
import { env } from 'utils/env';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Card, Typography } from '@totalsoft/rocket-ui';
import SettingsIcon from '@mui/icons-material/Settings';
import PropTypes from 'prop-types';
import LoadingWrapper from 'components/common/LoadingWrapper';
import { VersionList, VersionsWrapper } from './SettingsStyles';

const VersionsComponent = ({
  loadingGqlVersion,
  gqlVersion,
  loadingAPIVersion,
  apiVersion,
  loadingDatabaseVersion,
  databaseVersion,
  loadingInsuranceServiceVersion,
  insuranceServiceVersion,
  deimosVersion,
  erpVersion
}) => {
  const { t } = useTranslation();

  return (
    <Card title={t('Settings.Versions.Title')} icon={SettingsIcon}>
      <VersionsWrapper>
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{t('Settings.Versions.UIVersionLabel')}: </Typography>
            </Grid>
            <Grid item>
              <Typography>
                {t('Settings.Versions.UIVersionValue', {
                  data: {
                    version: env.REACT_APP_VERSION,
                    date: t('LONG_DATE', { date: env.REACT_APP_DATE })
                  }
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{t('Settings.Versions.GQLVersion')} </Typography>
            </Grid>
            <Grid item>
              <LoadingWrapper loading={loadingGqlVersion}>
                <Typography>
                  {`${gqlVersion?.version || ''} 
               ${t('Settings.Versions.GQLVersionLastUpdate', {
                 data: {
                   date: t('LONG_DATE', { date: gqlVersion?.date })
                 }
               })}`}
                </Typography>
              </LoadingWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{`${t('Settings.Versions.APIVersion')} `} </Typography>
            </Grid>
            <Grid item>
              <LoadingWrapper loading={loadingAPIVersion}>
                <Typography>
                  {apiVersion?.version || ''}
                  {t('Settings.Versions.APIVersionLastUpdate', {
                    data: {
                      date: t('LONG_DATE', { date: apiVersion?.date })
                    }
                  })}
                </Typography>
              </LoadingWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{`${t('Settings.Versions.InsuranceServiceVersion')}`} </Typography>
            </Grid>
            <Grid item>
              <LoadingWrapper loading={loadingInsuranceServiceVersion}>
                <Typography>
                  {`${insuranceServiceVersion?.version || ''} 
               ${t('Settings.Versions.InsuranceServiceVersionLastUpdate', {
                 data: {
                   date: t('LONG_DATE', { date: insuranceServiceVersion?.date })
                 }
               })}`}
                </Typography>
              </LoadingWrapper>
            </Grid>
          </Grid>
        </Grid>
        {deimosVersion && (
          <Grid container spacing={1}>
            <Grid item container spacing={1} xs={12}>
              <Grid item>
                <Typography fontWeight='bold'>{t('Settings.Versions.DeimosVersion')} </Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {`${deimosVersion?.version || ''} 
               ${t('Settings.Versions.DeimosVersionLastUpdate', {
                 data: {
                   date: t('LONG_DATE', { date: deimosVersion?.date })
                 }
               })}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{`${t('Settings.Versions.DatabaseVersion')} `} </Typography>
            </Grid>
            <Grid item>
              <LoadingWrapper loading={loadingDatabaseVersion}>
                <Typography>{databaseVersion || ''}</Typography>
              </LoadingWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item container spacing={1} xs={12}>
            <Grid item>
              <Typography fontWeight='bold'>{`${t('Settings.Versions.ErpVersion.Title')} `} </Typography>
              <LoadingWrapper loading={erpVersion.loading}>
                <VersionList>
                  <li>
                    <Typography>
                      {t('Settings.Versions.ErpVersion.Client')} {erpVersion.clientId}
                    </Typography>
                  </li>
                  <li>
                    <Typography>{erpVersion.version}</Typography>
                  </li>
                </VersionList>
              </LoadingWrapper>
            </Grid>
          </Grid>
        </Grid>
      </VersionsWrapper>
    </Card>
  );
};

VersionsComponent.propTypes = {
  loadingGqlVersion: PropTypes.bool.isRequired,
  gqlVersion: PropTypes.object,
  loadingAPIVersion: PropTypes.bool.isRequired,
  apiVersion: PropTypes.object,
  loadingDatabaseVersion: PropTypes.bool.isRequired,
  databaseVersion: PropTypes.string,
  loadingInsuranceServiceVersion: PropTypes.bool.isRequired,
  insuranceServiceVersion: PropTypes.object,
  deimosVersion: PropTypes.object,
  erpVersion: PropTypes.object
};

export default VersionsComponent;
